import Image from "next/image";

interface FallbackMessageProps {
  imageSrc?: string;
  title?: string;
  description?: string;
  className?: string;
}

export default function FallbackMessage({
  imageSrc = "/nothing-found.webp",
  title = "Kein Ergebnis gefunden.",
  description = "Bitte versuchen Sie einen anderen Suchbegriff.",
  className = "",
}: FallbackMessageProps) {
  return (
    <div
      className={`col-span-full flex min-h-[300px] w-full items-center justify-center ${className}`}
    >
      <div className="flex w-full flex-col items-center justify-center">
        <Image
          src={imageSrc}
          alt="Kein Ergebnis gefunden"
          width={180}
          height={180}
          className="mb-6"
          priority={false}
        />
        <h2 className="mb-2 text-center text-2xl font-semibold">{title}</h2>
        <p className="text-muted-foreground text-center text-lg">
          {description}
        </p>
      </div>
    </div>
  );
}
